var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a",
    { class: { rsp2EventNaviItem: true }, attrs: { href: _vm.url } },
    [
      _c("div", { staticClass: "rsp2Content" }, [
        _c("div", { staticClass: "rsp2Header" }, [_vm._v(_vm._s(_vm.header))]),
        _vm._v(" "),
        _c("div", { staticClass: "rsp2Title" }, [
          _vm.isNew
            ? _c("div", { staticClass: "rsp2Tag" }, [
                _c("span", [_vm._v("Neu")])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("span", { domProps: { innerHTML: _vm._f("hyphen")(_vm.title) } })
        ]),
        _vm._v(" "),
        _vm.description
          ? _c("div", { staticClass: "rsp2Description" }, [
              _vm._v(_vm._s(_vm.description))
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm.date
        ? _c("div", { staticClass: "rsp2Date" }, [
            _c("span", { staticClass: "rsp2Next" }, [
              _vm._v("Nächster Termin")
            ]),
            _vm._v(" "),
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "16",
                  height: "16",
                  viewBox: "0 0 20 20"
                }
              },
              [
                _c("path", {
                  attrs: {
                    id: "calendar",
                    d:
                      "M15.222,2.778h-.889V4.556H11.667V2.778H6.333V4.556H3.667V2.778H2.778A1.782,1.782,0,0,0,1,4.556V15.222A1.782,1.782,0,0,0,2.778,17H15.222A1.783,1.783,0,0,0,17,15.222V4.556A1.783,1.783,0,0,0,15.222,2.778Zm0,12.444H2.778V8.111H15.222ZM5.889,1H4.111V4.111H5.889Zm8,0H12.111V4.111h1.778Z"
                  }
                })
              ]
            ),
            _vm._v(" "),
            _c("span", { staticClass: "rsp2Value" }, [
              _vm._v(
                _vm._s(_vm._f("dayOfWeek")(_vm.date)) +
                  ". " +
                  _vm._s(_vm._f("formatDate")(_vm.date))
              )
            ]),
            _vm._v(" "),
            _c("a", { attrs: { href: _vm.url } }, [_vm._v("f")])
          ])
        : _c("div", { staticClass: "rsp2Date" }, [
            _c("span", { staticClass: "rsp2Next" }, [
              _vm._v("Derzeit keine Termine")
            ])
          ]),
      _vm._v(" "),
      _vm.dates.length
        ? _c("div", { staticClass: "rsp2Dates" }, [
            _c("span", { staticClass: "rsp2Next" }, [
              _vm._v("Nächster Termin")
            ]),
            _vm._v(" "),
            _c(
              "ul",
              _vm._l(_vm.dates, function(d, i) {
                return _c("li", { key: "" + i + d }, [
                  _c("span", { staticClass: "rsp2Value" }, [
                    _vm._v(
                      _vm._s(_vm._f("dayOfWeek")(d)) +
                        ". " +
                        _vm._s(_vm._f("formatDate")(d))
                    )
                  ])
                ])
              })
            ),
            _vm._v(" "),
            _c("a", { staticClass: "riButton", attrs: { href: _vm.url } }, [
              _vm._v("Details")
            ])
          ])
        : _c("div", { staticClass: "rsp2Dates" }, [
            _c("span", { staticClass: "rsp2Next" }, [
              _vm._v("Derzeit keine Termine")
            ])
          ]),
      _vm._v(" "),
      _c("div", { staticClass: "rsp2LeftBorder" })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }